export default function SmallCard({ number, text }) {
  return (
    <>
    <div className=" text-center shadow rounded-lg text-gray-700 hover:text-gray-900 hover:bg-violet-100 transition duration-300 ease-in-out">
      <div className="p-2">
        <div className="text-5xl font-semibold leading-tight text-violet-600">{number}</div>
      </div>
      <div className="px-2 pb-4">
        {text}
      </div>
    </div>
    </>
  )
}